import { Box, Column, InputTextField, Radio } from '@tempmee/react';
import { useId, type ChangeEvent } from 'react';

export interface IMethodRadioOptionProps {
  value: string;
  label: string;
  checked: boolean;
  onSelect: (value: string) => void;
  inputValue: string;
  onInputChange: (inputValue: string) => void;
  inputPlaceholder: string;
  inputType?: 'email' | 'tel' | 'text';
  isError?: boolean;
  inputId?: string;
  testId?: string;
  dataCy?: string;
}

export const MethodRadioOption = ({
  value,
  label,
  checked,
  onSelect,
  inputValue,
  onInputChange,
  inputPlaceholder,
  inputType = 'text',
  isError = false,
  inputId,
  testId,
  dataCy,
}: IMethodRadioOptionProps) => {
  const generatedId = useId();
  const resolvedInputId = inputId ?? `${generatedId}-input`;

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    onInputChange(event.target.value);
  };

  return (
    <Column gap={2} data-testid={testId} data-cy={dataCy}>
      <Radio
        value={value}
        checked={checked}
        onChange={onSelect}
        label={label}
        data-testid={testId ? `${testId}-radio` : undefined}
        data-cy={dataCy ? `${dataCy}-radio` : undefined}
      />
      {/* Indent input so it aligns with the radio label text, not the circle. */}
      <Box style={{ marginLeft: 26, width: '100%' }}>
        <InputTextField
          id={resolvedInputId}
          name={value}
          type={inputType}
          value={inputValue}
          onChange={handleInputChange}
          placeholder={inputPlaceholder}
          isError={isError}
          data-testid={testId ? `${testId}-input` : undefined}
          data-cy={dataCy ? `${dataCy}-input` : undefined}
        />
      </Box>
    </Column>
  );
};
